import {
	helmetAccessoryItem,
	homeChargerAccessoryItem,
	chargerAdapterAccessoryItem,
	jacketAccessoryItem,
} from './accessoryItem';

import { fuellVehicle1, fuellVehicle2 } from './vehicleItem';

const oemId = 'FmD37fiMKqoHgLZrr0vW';
const checkoutItems = [
	fuellVehicle1,
	fuellVehicle2,
	helmetAccessoryItem,
	helmetAccessoryItem,
	homeChargerAccessoryItem,
	homeChargerAccessoryItem,
	chargerAdapterAccessoryItem,
	jacketAccessoryItem,
];
// eslint-disable-next-line no-restricted-syntax
for (const item of checkoutItems) {
	item.oemId = oemId;
}

const fuellDummyData = {
	checkoutItems,
	prevPage: '/',
	oemLogo:
		'https://cdn.shopify.com/s/files/1/0451/7488/2457/files/FUELL_LOGO_Mini_287x.png?v=1613766535',
};

export default fuellDummyData;
